export const ReviewForm = () => {
  return (
    <form>
      <h2>Post a review</h2>
      <label></label>
    </form>
  );
};
